import { render } from "./AnalysisToolQA.vue?vue&type=template&id=1772bd9a&scoped=true"
import script from "./AnalysisToolQA.vue?vue&type=script&lang=js"
export * from "./AnalysisToolQA.vue?vue&type=script&lang=js"

import "./AnalysisToolQA.vue?vue&type=style&index=0&id=1772bd9a&scoped=true&lang=css"
import "./AnalysisToolQA.vue?vue&type=style&index=1&id=1772bd9a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1772bd9a"]])

export default __exports__